// i18n area 'vms' — locale ro-RO (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.ro-RO.meta.json.
import type { enUS } from './vms'

export const roRO: typeof enUS = {
  vms: {
    spof: {
      title: 'Independența de nod',
      single: 'Punct unic de defecțiune',
      alternativesNow: 'Alternative acum',
      structural: 'Prin construcție',
      binding: 'Constrângere determinantă',
      movableNow: 'Migrare posibilă acum',
    },
    title: 'Mașini virtuale',
    migratingChip: 'Migrare în curs',
    templateChip: 'Template',
    expendableTooltip: 'Într-un cluster degradat este printre primele oprite și s-ar putea să nu repornească după pierderea unui nod.',
    expendableHaTooltip: 'Repornită mereu cât timp clusterul este sănătos; într-un cluster degradat VM-urile protejate au prioritate — poate fi oprită sau poate rămâne stinsă până când clusterul redevine întreg, apoi repornește singură.',
    viewDetails: 'Vezi detaliile',
    profileLegacy: 'Alt OS',
    hugePagesNone: 'Niciuna — memorie normală',
    hugePages2M: 'Pagini de 2 MiB',
    hugePages1G: 'Pagini de 1 GiB',
    searchPlaceholder: 'Caută după nume',
    name: 'Nume',
    vcpus: 'vCPU',
    memory: 'Memorie',
    ipAddresses: 'Adrese IP',
    noIp: 'Fără IP',
    authorityNode: 'Authority',
    authorityNextStart: 'se atribuie la următoarea pornire',
    scope: 'Scope',
    empty: 'Nicio mașină virtuală',
    loadError: 'Nu s-au putut încărca mașinile virtuale — este accesibil backend-ul TVirt?',
    filterOverlay: 'rețea overlay',
    filterDisk: 'disc',
    filterImage: 'imagine',
    filteredBy: 'Filtrate după {kind}',
    filterPhase: 'Fază',
    filterProtection: 'Protecție',
    filterAll: 'Toate',
    filterScopePlaceholder: 'Filtrează după scope',
    filtersToggle: 'Filtre',
    scopeTree: {
      title: 'Scope-uri',
      all: 'Întregul cluster',
      noChildren: 'Niciun sub-scope aici',
      recursive: 'Include descendenții',
      collapse: 'Restrânge panoul de scope-uri',
      up: 'Un nivel mai sus',
      countTooltip: '{direct} VM în acest scope · {total} cu descendenții'
    },
    isoPicker: {
      catalog: 'Catalog',
      unknownCatalog: 'În afara cataloagelor vizibile',
      noIsos: 'Nicio imagine ISO gata în acest catalog'
    },
    actionsHeader: 'Acțiuni',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Hardware',
      tags: 'Taguri',
      age: 'Vechime',
      disk: 'disc',
      disks: 'discuri',
      empty: 'Niciun template — marchează ca template o VM stinsă sau clonează o VM ca template.',
      clone: 'Clonează / implementează',
      editTags: 'Modifică tagurile',
      exportAction: 'Exportă în catalog (.tvtpl)',
      exportTitle: 'Exportă în catalog',
      exportSubmit: 'Exportă',
      exportError: 'Exportul a eșuat',
      exportHint: 'Template-ul este împachetat într-o arhivă .tvtpl (manifest hardware + fiecare disc aplatizat în qcow2) ca fișier Template VM nou în catalogul ales. NIC-urile, mediile CD/DVD și cloud-init nu călătoresc — specificația formatului enumeră fiecare omisiune deliberată.',
      exportName: 'Numele fișierului',
      exportNameHint: 'Gol = <template>-export-<n>',
      exportStorageDefault: 'Storage-ul de metadate al template-ului',
      importAction: 'Importă din catalog',
      importTitle: 'Importă din catalog',
      importHint: 'Un fișier Template VM gata din catalogul ales devine un template al inventarului: formatul fișierului (tvtpl, ova, ovf sau qcow2 brut) decide singur cum se importă — tu alegi doar fișierul.',
      importFile: 'Fișier de catalog',
      importFileHint: 'Se importă doar fișiere gata — unul aflat la jumătatea upload-ului nu este importabil',
      importNoFiles: 'Niciun fișier Template VM gata în acest catalog — încarcă sau exportă mai întâi unul'
    },
    templateDetail: {
      quickDeploy: 'Compatibilitate QuickDeploy',
      quickDeployNone: 'Nedeclarată',
      quickDeployHint: 'Declar-o doar dacă imaginea golden conține cloud-init (Linux) sau cloudbase-init după sysprep /generalize (Windows): platforma are încredere în declarație și nu se uită niciodată în interiorul guestului.',
      notFound: 'Template-ul nu a fost găsit',
      frozen: 'Configurația hardware este înghețată: reconvertește template-ul în VM ca s-o modifici. Numele, notele și tagurile rămân editabile.',
      storage: 'Storage',
      size: 'Dimensiune',
      configTitle: 'Configurație (înghețată)',
      usbClasses: 'Clase USB necesare',
      gpuClasses: 'Clase GPU necesare'
    },
    sharedDisksTab: {
      title: 'Discuri partajate',
      sharing: 'Partajare',
      sharingNone: 'Un singur attach',
      sharingMultiwriter: 'Scriere partajată (multiwriter)',
      sharingReadonly: 'Doar citire partajată',
      usedBy: 'Folosit de',
      attachedTo: 'Atașat la',
      notAttached: 'Atașat la nicio VM',
      changeSharing: 'Schimbă modul de partajare',
      changeSharingTitle: 'Mod de partajare',
      changeSharingLocked: 'Modul se schimbă doar cât timp nicio VM nu folosește discul',
      sharingChanged: 'Mod de partajare actualizat.',
      lun: 'LUN întreg',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Serie',
      antiAffinityWarning: 'Doi sau mai mulți membri rulează pe același nod fără o regulă de anti-afinitate: căderea unui nod îi doboară pe toți',
      antiAffinityCreate: 'Creează regula',
      createSourceLun: 'Adoptă un LUN întreg al target-ului',
      createLunNumber: 'Numărul LUN (id de namespace pe NVMe)',
      createLunHint: 'Nu se alocă nimic: dimensiunea se observă pe dispozitiv la adoptare',
      noPr: 'În această versiune nu există SCSI-3 persistent reservations: un Windows Failover Cluster cu disc partajat clasic nu este validat; clusterele care se coordonează prin rețea (GFS2/OCFS2, RHEL HA, baze de date shared-disk) da'
    },
    unusedDisksTab: {
      title: 'Discuri nefolosite',
      attach: 'Atașează la o VM',
      attachTitle: 'Atașează la o VM',
      vm: 'Mașină virtuală',
      noVms: 'Nicio VM disponibilă',
      noSlots: 'Niciun slot liber pe această VM',
      create: 'Creează disc',
      createTitle: 'Creează disc',
      createSourceBlank: 'Disc gol',
      createSourceImage: 'Dintr-o imagine din catalog',
      createImage: 'Imagine',
      createImageEmpty: 'Nicio imagine de șablon VM pregătită în cataloagele vizibile',
      createSizeFromImageHint: 'Precompletat cu dimensiunea virtuală a imaginii — poate doar crește',
      convert: 'Convertește în template VM…',
      convertOnlyQcow2: 'Se convertesc doar discuri qcow2 — raw nu este un format de template înregistrabil',
      convertTitle: 'Convertește în template VM',
      convertSubmit: 'Convertește (distruge discul)',
      convertError: 'Conversia nu a putut porni',
      convertWarning: 'DISTRUCTIV: discul devine un fișier template VM în catalogul ales — același storage, zero octeți copiați — și ÎNCETEAZĂ SĂ EXISTE ca disc. Nu există cale înapoi decât creând un disc nou din template.',
      convertNameHint: 'Numele fișierului de catalog — implicit cel al discului',
      convertConfirm: 'Am înțeles: discul va fi distrus',
      convertStarted: 'Conversia a pornit — template-ul apare în catalog la finalul taskului.',
      storageLockHint: 'Storage-ul se schimbă doar prin acțiunea Mută',
      source: 'Proveniență',
      sourceClone: 'Clonă a altui disc',
      sourceCloneLinked: 'Linked clone al altui disc',
      sourceImage: 'Creat dintr-o imagine',
      sourceBlank: 'Creat gol',
      allocated: 'Alocat / dimensiune virtuală',
      observedAt: 'Observat la',
      snapshots: 'Snapshoturi',
      snapshotsEmpty: 'Niciun snapshot'
    },
    phase: {
      defined: 'Niciodată pornită',
      starting: 'Se pornește',
      running: 'În execuție',
      stopping: 'Se oprește',
      stopped: 'Stinsă',
      paused: 'În pauză',
      failed: 'În eroare',
      deleting: 'În ștergere'
    },
    stopCause: {
      'api': 'Oprită de TVirt (acțiune sau API)',
      'guest-shutdown': 'Shutdown inițiat de sistemul de operare guest',
      'crash': 'Crash al guestului',
      'qemu-exit': 'Procesul QEMU s-a terminat pe neașteptate',
      'host-reboot': 'Nodul a fost repornit',
      'migrated': 'Migrată pe alt nod',
      'fenced': 'Terminată de fencingul HA (nod revenit)'
    },
    detail: {
      notFound: 'Mașina virtuală nu a fost găsită',
      details: 'Detalii',
      id: 'ID',
      scope: 'Scope',
      profile: 'Profil hardware',
      firmware: 'Firmware',
      firmwareFile: 'Versiune firmware UEFI',
      firmwareUpdate: 'Actualizare disponibilă',
      firmwareUpdateHint: 'Platforma livrează un firmware UEFI mai nou. Actualizarea nu este niciodată automată: se aplică cu VM-ul stins, când decizi tu.',
      arch: 'Arhitectură',
      node: 'Nod',
      bootOrder: 'Ordinea de boot',
      agent: 'Stare agent',
      agentConnected: 'Conectat',
      agentNotConnected: 'Neconectat',
      protected: 'Protejată',
      linkedClones: 'Clone legate',
      restartPolicy: 'Politică de repornire',
      preferredNode: 'Nod preferat',
      noPreference: 'Nicio preferință (plasare automată)',
      preferNodes: 'Taguri de nod preferate',
      requireNodes: 'Taguri de nod obligatorii',
      noPlacementTags: 'Niciunul',
      placementTag: 'Tag',
      placementValue: 'Valoare',
      placementAddTag: 'Adaugă tag',
      proximityHa: 'HA TVirt Proximity',
      proximityHaRestarts: 'reporniri HA',
      proximityHaGaveUp: 'crash loop — HA a renunțat',
      failoverProtection: 'Protecție în cluster degradat',
      protectionProtected: 'Protejată',
      protectionExpendable: 'Sacrificabilă în degradare',
      protectionInherit: 'Moștenește',
      lastStop: 'Ultima oprire',
      yes: 'Da',
      no: 'Nu',
      tabOverview: 'Prezentare generală',
      tabSnapshots: 'Snapshoturi',
      tabBackups: 'Copii',
      hardware: 'Hardware',
      name: 'Nume',
      hwSystem: 'Sistem',
      hwCpu: 'CPU',
      hwMemory: 'Memorie',
      hwBoot: 'Pornire',
      hwIdentity: 'Identitate',
      hwCluster: 'Cluster și agent',
      cpuTopology: 'Topologie CPU',
      cpuModel: 'Model CPU',
      cpuLimit: 'Limită CPU',
      cpuWeight: 'Pondere CPU',
      cpuNested: "Virtualizare imbricată",
      cpuNestedHint: "Expune vmx/svm oaspetelui (doar cu modelul CPU host). Pe o VM pornită, modificarea se aplică la următorul power cycle (PendingRestart); plasarea admite doar noduri cu nested activat.",
      unlimited: 'Nelimitat',
      memory: 'Memorie',
      balloon: 'Balloon',
      hugePages: 'Pagini uriașe',
      hugePagesTradeoff: 'Mai puțină muncă de traducere a adreselor și memorie care nu ajunge niciodată pe disc; în schimb rezervarea rămâne blocată pe nod cât timp VM-ul este pornit, memoria nu se mai deduplică, iar pornirea eșuează dacă nodul nu are destule pagini libere.',
      disks: 'Discuri',
      cdroms: 'Unități CD/DVD',
      nics: 'Interfețe de rețea',
      slot: 'Slot',
      disk: 'Disc',
      encrypted: 'Criptat',
      image: 'Imagine',
      emptyDrive: 'Unitate goală',
      emptyOption: '(gol)',
      network: 'Rețea',
      mac: 'MAC',
      connected: 'Conectată',
      unplugged: 'Deconectată',
      noDevices: 'Niciunul',
      screenshot: 'Captură de ecran',
      capturedAt: 'Capturată la',
      noCapture: 'Nicio captură',
      snapshotName: 'Nume',
      snapshotCreated: 'Creat',
      snapshotMemory: 'Memorie inclusă',
      noSnapshots: 'Niciun snapshot',
      pendingRestart: 'Modificări în așteptare: se vor aplica la următorul power cycle.',
      applied: 'aplicat',
      appliedHint: 'VM-ul rulează cu această valoare — cea configurată se aplică la următorul power cycle.',
      actionError: 'Acțiunea a eșuat',
      actionStillRunning: 'Acțiunea este încă în curs: rezultatul nu este încă cunoscut',
      tabConsole: 'Consolă',
      consoleConnect: 'Conectează',
      consoleDisconnect: 'Deconectează',
      consoleConnecting: 'Conectare…',
      consoleReconnecting: 'Conectare…',
      consoleUnavailable: 'Consola este disponibilă cu VM-ul în execuție sau în pauză.',
      consoleError: 'Conectarea la consolă a eșuat',
      consoleTaken: 'Sesiunea de consolă a fost preluată de {user}',
      consoleReconnect: 'Reconectează',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Ține apăsat {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Deschide pe tot ecranul într-o filă nouă',
      consoleLoadFailed: 'VM negăsită sau permisiuni insuficiente',
      consoleClose: 'Închide',
      tabStats: 'Statistici',
      tabTasks: 'Taskuri',
      tabLogs: 'Loguri',
      statsCpu: 'CPU',
      statsMemory: 'Memorie',
      statsDisk: 'I/O disc',
      statsRange: 'Interval',
      statsNoData: 'Nu există date în intervalul ales — statisticile se eșantionează cu VM-ul în execuție.',
      statsError: 'Nu s-au putut încărca statisticile',
      cpuUsage: 'Utilizare',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Utilizată',
      memGuestAvailable: 'Disponibilă (guest)',
      schema: 'Schemă',
      consoleProtocol: 'Consolă',
      agentEnabled: 'Agent guest',
      metadataStorage: 'Storage de metadate',
      startupOnBoot: 'Pornire la boot',
      startupOrder: 'Ordinea de pornire',
      startupDelay: 'Întârziere la pornire',
      seconds: 's',
      enabled: 'Activat',
      disabled: 'Dezactivat'
    },
    actionsAvailable: 'Acțiuni disponibile',
    actions: {
      start: 'Pornește',
      stop: 'Oprește',
      pause: 'Pauză',
      resume: 'Reia',
      reset: 'Resetează',
      migrate: 'Migrează',
      clone: 'Clonează',
      moveStorage: 'Mută pe storage…',
      moveScope: 'Mută în scope…',
      openConsole: 'Deschide consola',
      forceStop: 'Forțează stingerea',
      markTemplate: 'Marchează ca template',
      unmarkTemplate: 'Reconvertește în VM',
      error: 'Nu s-a putut executa acțiunea'
    },
    cordon: {
      confirmTitle: 'Nodul este în mentenanță',
      confirmHint:
        'Cordonul nu poate fi coborât cât timp store-ul clusterului este indisponibil. Confirmând declari că știi: VM-ul pornește acolo oricum, iar consimțământul rămâne înregistrat pe task.',
      confirm: 'Pornește oricum'
    },
    markTemplate: {
      confirmTitle: 'Marchezi {name} ca template?',
      confirmBody: 'Configurația îngheață, iar VM-ul nu mai poate fi pornit — doar clonat sau readus la VM. Numele, notele și tagurile rămân editabile.',
      confirm: 'Marchează ca template',
      moved: '{name} este acum un template — s-a mutat în fila Template.'
    },
    unmarkTemplate: {
      confirmTitle: 'Reconvertești {name} în VM?',
      confirmBody: 'Template-ul redevine o VM obișnuită: editabilă și pornibilă (următoarea pornire o plasează pe un nod).',
      confirm: 'Reconvertește în VM',
      moved: '{name} este din nou o mașină virtuală — s-a mutat în fila Mașini virtuale.'
    },
    nodeByTag: {
      label: 'După tag de nod',
      hint: 'tag=valoare, separate prin virgulă (în AND): deciderul alege dintre nodurile care corespund',
      invalid: 'Format invalid — folosește tag=valoare, separate prin virgulă',
      resolved: 'Membri corespunzători: {nodes}'
    },
    migrate: {
      title: 'Migrare live',
      submit: 'Migrează',
      target: 'Nod de destinație',
      auto: 'Automat (Proximity)',
      hint: 'VM-ul se mută fără power cycle. Fiecare storage pe care îl atinge trebuie să fie partajat; o VM în pauză migrează în pauză.',
      error: 'Migrarea a fost refuzată'
    },
    moveStorage: {
      title: 'Mută pe storage',
      submit: 'Mută',
      target: 'Storage de destinație',
      noTargets: 'Niciun storage nu acceptă discuri',
      hint: 'Toate discurile VM-ului stins călătoresc pe storage-ul ales, unul câte unul, păstrându-și id-ul — cele deja la destinație sunt sărite. Progresul se urmărește în pagina de taskuri.',
      error: 'Mutarea a fost refuzată'
    },
    moveScope: {
      title: 'Mută în scope',
      submit: 'Mută',
      target: 'Scope de destinație',
      hint: 'VM-ul schimbă scope-ul imediat — id-ul și discurile rămân, discurile owned îl urmează și poate rămâne pornit. Astăzi trăiește în {scope}. Cine îl vede se schimbă odată cu scope-ul.',
      error: 'Mutarea de scope a fost refuzată'
    },
    start: {
      title: 'Pornește VM',
      submit: 'Pornește',
      target: 'Nod de destinație',
      auto: 'Automat (recomandat)',
      recommended: 'recomandat',
      hint: 'Alege un nod de destinație sau lasă Proximity să decidă între candidații valizi. Nodurile care nu pot găzdui VM-ul sunt dezactivate, cu motivul afișat.',
      error: 'VM-ul nu a putut fi pornit'
    },
    console: {
      media: 'Unități CD/DVD',
      mediaGuestToolsHint: 'Conține TVirt Guest Tools — de aici le poți ejecta sau poți elimina unitatea',
      slotOpsDeferred: 'Pe acest profil adăugarea și eliminarea unităților se aplică la următorul power cycle (schimbările de mediu sunt imediate).',
      mountGuestTools: 'Montează TVirt Guest Tools',
      ejectGuestTools: 'Ejectează TVirt Guest Tools',
      bootOrder: 'Ordinea de boot',
      bootOrderHint: 'Noua ordine se salvează imediat și se aplică la următorul power cycle — sesiunea de consolă rămâne conectată.'
    },
    snapshots: {
      create: 'Creează snapshot',
      createTitle: 'Creează un snapshot',
      createSubmit: 'Creează',
      name: 'Nume',
      nameHint: 'Litere, cifre, punct, cratimă, underscore.',
      consistencyHint: 'Consistența este automată: agentul guest îngheață sistemele de fișiere când răspunde; altfel VM-ul intră în pauză pentru o clipă în jurul snapshotului.',
      memory: 'Include memoria',
      memoryHint: 'Capturează RAM-ul viu: restaurarea reia VM-ul în execuție. Cere ca toate discurile să fie qcow2.',
      currentChip: 'Ești aici',
      revert: 'Restaurează',
      revertTitle: 'Restaurezi {name}?',
      revertBody: 'Discurile revin la starea din snapshot; tot ce s-a întâmplat după se pierde. Un snapshot doar-discuri cere VM-ul oprit.',
      delete: 'Șterge',
      deleteTitle: 'Ștergi snapshotul {name}?',
      deleteBody: 'Punctul de restaurare dispare; conținutul discurilor rămâne intact.',
      deleteMergeHint: 'Delta sa se contopește în {children}: fiecare punct de restaurare ulterior rămâne valid.',
      deleteDuplication: 'Accept duplicarea',
      deleteDuplicationHint: 'Delta este copiată în fiecare dintre cei {count} cititori (snapshot-urile copil și, dacă acesta este cel curent, capul activ): spațiul ocupat poate crește în loc să scadă.',
      error: 'Operația pe snapshot a fost refuzată'
    },
    clone: {
      title: 'Clonează VM',
      submit: 'Clonează',
      name: 'Numele copiei',
      storage: 'Storage-ul de destinație al discurilor',
      sameStorage: 'La fel ca sursa',
      full: 'Copie completă',
      fullHint: 'Copiază fiecare octet și rupe legătura cu discurile sursă. Implicitul este un linked clone: instantaneu, dar înlănțuit de sursă (doar qcow2).',
      hint: 'Clona păstrează configurația și firmware-ul sursei; adresele MAC și identitatea TPM sunt noi.',
      markAs: 'Tipul clonei',
      markAsInheritVm: 'Ca sursa (VM)',
      markAsInheritTemplate: 'Ca sursa (template)',
      markAsVm: 'Mașină virtuală',
      markAsTemplate: 'Template',
      markAsHintVm: 'Alege Template ca să promovezi copia dintr-un singur pas.',
      markAsHintTemplate: 'Alege Mașină virtuală ca să implementezi din acest template dintr-un singur pas.',
      error: 'Clonarea a fost refuzată'
    },
    bulk: {
      selected: 'selectate',
      deleteTitle: {
        one: 'Ștergi VM-ul selectat ({count})?',
        few: 'Ștergi VM-urile selectate ({count})?',
        other: 'Ștergi VM-urile selectate ({count})?'
      },
      deleteBody: 'Fiecare VM trece prin aceleași verificări ca la ștergerea individuală; refuzurile se raportează per element.',
      done: 'acceptate',
      refused: 'refuzate'
    },
    delete: {
      button: 'Șterge',
      confirmTitle: 'Ștergi {name}?',
      confirmBody: 'Mașina virtuală și discurile pe care le deține vor fi șterse. Operația nu este reversibilă.',
      keepDisks: 'Păstrează discurile',
      keepDisksHint: 'Discurile create odată cu VM-ul rămân în storage-ul lor ca discuri de sine stătătoare.',
      confirm: 'Șterge',
      cancel: 'Anulează',
      error: 'Ștergerea a eșuat',
      blockedPhase: 'Oprește mai întâi VM-ul',
      blockedProtected: 'VM-ul este protejat — elimină mai întâi protecția',
      blockedDeleting: 'Ștergerea este deja în curs'
    },
    logs: {
      title: 'Loguri',
      subtitle: 'Frame-uri de log structurate din taskurile care ating această VM',
      when: 'Când',
      task: 'Task',
      level: 'Nivel',
      message: 'Mesaj',
      empty: 'Încă niciun log',
      loadError: 'Nu s-au putut încărca logurile — este accesibil backend-ul TVirt?'
    },
    stop: {
      title: 'Oprește mașina virtuală',
      modeGraceful: 'Stingere graceful',
      modeGracefulHint: 'Sistemului de operare guest i se cere să se stingă în mod curat (ACPI); dacă ignoră cererea, după timeout urmează stingerea forțată.',
      modeForced: 'Stingere forțată',
      modeForcedHint: 'Taie curentul imediat, ca și cum ai scoate ștecherul din priză.',
      timeout: 'Timeout de fallback (secunde)',
      timeoutHint: 'Așteptarea acordată guestului înainte de a forța stingerea'
    },
    createFromScratch: 'De la zero',
    createFromTemplate: 'Din template',
    createQuickDeploy: 'TVirt QuickDeploy',
    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Execută deploy',
      error: 'Deploy eșuat',
      compatNote: 'QuickDeploy necesită un șablon compatibil QuickDeploy: platforma personalizează guestul (rețea, domeniu, activare) la prima pornire.',
      template: 'Șablon',
      noTemplates: 'Niciun șablon nu declară încă compatibilitatea QuickDeploy — declar-o din fila Șabloane (Linux cu cloud-init, Windows cu cloudbase-init după sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Nume de host',
      hostnameHint: 'Nume de host sau FQDN; gol = numele VM-ului (Windows: cel mult 15 caractere)',
      ip: 'Adresă IP',
      ipHint: 'Host și prefix, de ex. 192.168.122.101/24; gol = DHCP',
      gateway: 'Gateway',
      dns: 'Servere DNS',
      dnsHint: 'Până la trei, separate prin virgulă',
      count: 'Instanțe',
      countHint: 'Mai mult de una: numite <nume>-1…-N, doar DHCP',
      user: 'Utilizator',
      userHint: 'Gol = utilizatorul implicit al imaginii (Linux) sau Administrator (Windows)',
      password: 'Parolă',
      passwordHint: 'Scrisă în user-data generată, pe care platforma o declară apoi secretă: nimeni nu o mai citește',
      sshKeys: 'Chei publice SSH',
      sshKeysHint: 'Una pe linie (ssh-ed25519 AAAA… comentariu)',
      productKey: 'Cheie de produs Windows',
      kmsServer: 'Server KMS',
      kmsHint: 'Host sau host:port — necesită o cheie de produs (o cheie client KMS)',
      adDomain: 'Alătură domeniului Active Directory',
      adDomainHint: 'Gol = fără alăturare la domeniu',
      adUser: 'Cont de alăturare',
      adPassword: 'Parola contului de alăturare',
      adOu: 'OU țintă (opțional)',
      advanced: 'Avansat: documente brute',
      userData: 'user-data (brută)',
      userDataHint: 'Înlocuiește user-data generată: utilizatorul, parola, cheile și câmpurile Windows de mai sus trebuie să rămână goale',
      networkConfig: 'network-config (brută)',
      networkConfigHint: 'Înlocuiește rețeaua generată: IP, gateway și DNS de mai sus trebuie să rămână goale',
      secret: 'Tratează user-data brută ca secretă',
      secretHint: 'Marcată secretă, API-ul nu o mai returnează nimănui și călătorește în Checkpoint sigilată cu masterpass',
      startNow: 'Pornește imediat',
      startNowHint: 'Fiecare instanță pornește de îndată ce este definită; seed-ul se naște la acea pornire'
    },
    create: {
      nicAttachmentNetwork: 'Rețea logică (fabric)',
      nicNetwork: 'Rețea logică',
      nicNetworkHint: 'Calea RECOMANDATĂ (F3): vNIC-ul se realizează pe bridge-ul DERIVAT al nodului servitor — bridge-ul se naște la apply-ul explicit al fabric-ului, iar o pornire pe un nod care nu-l poartă încă refuză vorbind. Când pleacă ultima referință a flotei, bridge-ul cade la următorul apply.',
      button: 'Creează VM',
      title: 'Creează mașină virtuală',
      dialogTitle: 'Creează mașină virtuală',
      stepGeneral: 'General',
      stepGeneralHint: 'Nume și profil',
      stepCompute: 'CPU și RAM',
      stepComputeHint: 'Topologie și dimensionare',
      stepDisks: 'Discuri',
      stepDisksHint: 'Creează sau atașează',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Unități și medii',
      stepNetwork: 'Rețea',
      stepNetworkHint: 'NIC-uri: trunk sau bridge',
      stepSummary: 'Rezumat',
      stepSummaryHint: 'Verifică și creează',
      name: 'Nume',
      nameHint: 'Litere mici, cifre și cratime (DNS-1123)',
      nextButton: 'Înainte',
      prevButton: 'Înapoi',
      submitButton: 'Creează',
      creating: 'Se creează…',
      sockets: 'Socketuri',
      cores: 'Core-uri pe socket',
      threads: 'Thread-uri pe core',
      totalVcpus: 'Total vCPU',
      memoryGib: 'Memorie (GiB)',
      cpuModelHint: "'host' expune CPU-ul hostului",
      cpuLimitHint: 'Plafon în core-uri de host — gol = nelimitat',
      cpuNestedHint: "Expune vmx/svm oaspetelui ca să poată rula propriul hipervizor — necesită modelul CPU host și un nod cu nested activat",
      newDisk: 'Disc nou',
      attachDisk: 'Atașează un disc existent',
      diskStorage: 'Storage',
      diskSize: 'Dimensiune (GiB)',
      diskSelect: 'Disc',
      addDisk: 'Adaugă disc',
      addCdrom: 'Adaugă unitate CD/DVD',
      addNic: 'Adaugă interfață de rețea',
      remove: 'Elimină',
      slotLimit: 'Limita de sloturi atinsă',
      cdromImage: 'Imagine (unitate goală dacă lipsește)',
      nicAttachment: 'Atașare',
      nicAttachmentTrunk: 'Trunk overlay',
      nicAttachmentBridge: 'Bridge de host',
      nicUntagged: 'Overlay untagged',
      nicUntaggedNone: 'Niciuna (doar tagged)',
      nicTrunkHint: 'Cel puțin o latură: o rețea overlay untagged și/sau mapări VLAN tagged — VM-ul poate rula doar pe hosturile declarate de fiecare overlay referențiat',
      nicTaggedVlan: 'ID VLAN',
      nicTaggedOverlay: 'Rețea overlay',
      addTagged: 'Adaugă VLAN tagged',
      nicBridge: 'Numele bridge-ului de host',
      nicBridgeHint: 'Bridge NM după nume — VM-ul poate rula doar pe serverele a căror rețea de host declară acest bridge',
      nicMac: 'MAC (auto dacă e gol)',
      noDisksHint: 'Niciun disc: VM-ul va avea doar unitățile CD/DVD pe care le adaugi.',
      noCdromsHint: 'Nicio unitate CD/DVD: adaugă una ca să pornești dintr-o imagine ISO.',
      mountGuestTools: 'Montează TVirt Guest Tools la prima pornire',
      mountGuestToolsHint: 'Pune ISO-ul cu driverele virtio și agentul guest într-o unitate CD goală (adăugată dacă e nevoie) — installerul de Windows are nevoie de ele ca să-și vadă discurile.',
      noNicsHint: 'Nicio interfață de rețea: VM-ul va porni fără conectivitate.',
      taggedMappings: 'Mapări VLAN tagged',
      summaryDevices: 'Dispozitive',
      bootOrderTitle: 'Ordinea de boot',
      bootOrderHint: 'Trage pentru a reordona — câștigă primul dispozitiv bootabil; NIC-urile fac boot PXE',
      bootOrderUp: 'Mută în sus',
      bootOrderDown: 'Mută în jos',
      createError: 'Crearea a eșuat'
    },
    edit: {
      button: 'Modifică',
      title: 'Modifică mașina virtuală',
      cancel: 'Anulează',
      save: 'Salvează',
      error: 'Modificarea a eșuat',
      modelStoppedOnly: 'Modificabil doar cu VM-ul stins',
      firmwareStoppedOnly: 'Firmware-ul se poate modifica doar cu VM-ul stins — la următoarea pornire mașina pornește cu firmware-ul nou, iar variabilele UEFI rămân',
      hugePagesStoppedOnly: 'Modificabil doar cu VM-ul stins — la următoarea pornire memoria se construiește pe noul backing',
      runningHint: 'Modificările se aplică la următorul power cycle',
      sectionCpu: 'CPU',
      sectionMemory: 'Memorie',
      sectionPolicy: 'Politici'
    },
    devices: {
      networkChip: 'rețea fabric',
      title: 'Dispozitive',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Adaugă dispozitiv USB',
      addUsbTitle: 'Cere o clasă de dispozitive USB',
      usbClassHint:
        'VM-ul cere o CLASĂ de dispozitive USB (o valoare a unui tag usb-device), niciodată un dispozitiv anume: la pornire, dispozitivul liber concret este ales și rezervat pe nod. Taghează dispozitivele înregistrate în Cluster › Resurse USB și PCIe.',
      usbTag: 'Tag (usb-device)',
      usbValue: 'Valoarea clasei',
      noUsbTags: 'Niciun tag usb-device — creează unul și taghează dispozitivele înregistrate în Cluster › Resurse USB și PCIe.',
      noUsbValues: 'Acest tag nu are încă valori declarate.',
      usbEmpty: 'Nicio cerință USB — adaugă o clasă pentru passthrough-ul unui dispozitiv la pornire.',
      usbClassChip: 'clasă',
      usbPortChip: 'port',
      usbUnclaimed: 'Niciun dispozitiv rezervat — se rezolvă la pornirea VM-ului.',
      addGpu: 'Adaugă GPU',
      addGpuTitle: 'Cere o clasă de GPU',
      gpuClassHint:
        'VM-ul cere o CLASĂ de GPU (o valoare a unui tag gpu-device), niciodată o placă anume: la pornire, placa liberă concretă este aleasă și rezervată pe nod, iar întregul ei grup IOMMU trece ÎMPREUNĂ. Taghează GPU-urile înregistrate în Cluster › Resurse USB și PCIe.',
      gpuTag: 'Tag (gpu-device)',
      gpuValue: 'Valoarea clasei',
      noGpuTags: 'Niciun tag gpu-device — creează unul și taghează GPU-urile înregistrate în Cluster › Resurse USB și PCIe.',
      noGpuValues: 'Acest tag nu are încă valori declarate.',
      gpuEmpty: 'Nicio cerință GPU — adaugă o clasă pentru passthrough-ul unei plăci la pornire.',
      gpuClassChip: 'clasă',
      gpuGroupChip: 'grup IOMMU ×',
      gpuUnclaimed: 'Nicio placă rezervată — se rezolvă la pornirea VM-ului.',
      gpuPowerCycle: 'Fără hotplug GPU — modificările se aplică de la următorul power cycle (PendingRestart)',
      actions: 'Acțiuni',
      attachDisk: 'Adaugă disc',
      attachDiskTitle: 'Adaugă un disc',
      attach: 'Atașează',
      noFreeDisks: 'Niciun disc nefolosit — creează unul în Mașini virtuale › Discuri nefolosite.',
      addCdrom: 'Adaugă unitate',
      addCdromTitle: 'Adaugă o unitate CD/DVD',
      editCdromTitle: 'Schimbă imaginea CD/DVD',
      changeMedia: 'Schimbă imaginea CD/DVD',
      ejectMedium: 'Ejectează',
      mountGuestTools: 'Montează TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools montate',
      guestToolsClickMount: 'Pune ISO-ul TVirt Guest Tools în prima unitate CD/DVD goală',
      guestToolsClickUnmount: 'Clic pentru a ejecta — unitatea rămâne, goală',
      guestToolsNoSlot: 'Nicio unitate CD/DVD goală — adaugă o unitate (sau ejectează un mediu) ca să montezi TVirt Guest Tools',
      guestToolsSkew: 'Montată v{pinned}; nodul {node} servește acum v{current}: scoate și remontează pentru a actualiza',
      ejectGuestTools: 'Ejectează TVirt Guest Tools (unitatea rămâne, goală)',
      guestToolsEjectConfirmTitle: 'Ejectezi TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Mediul este ejectat din VM-ul pornit — unitatea CD/DVD rămâne, goală.',
      applyLive: 'Aplică imediat (VM-ul este pornit)',
      addNic: 'Adaugă interfață',
      addNicTitle: 'Adaugă o interfață de rețea',
      editNicTitle: 'Modifică interfața de rețea',
      bridgeChip: 'bridge',
      cable: 'Cablu virtual',
      plug: 'Conectează cablul virtual',
      unplug: 'Deconectează cablul virtual',
      remove: 'Elimină',
      removeTitle: 'Elimini {device}?',
      removeBody: 'Cu VM-ul pornit, modificarea se aplică la următorul power cycle. Discurile și imaginile sunt detașate, niciodată șterse.'
    }
  }
}
